import {HttpContext, HttpContextToken} from '@angular/common/http';
import {ContextTypes, ContextOptions} from '../../models/context';

export const CONTEXT = new HttpContextToken<ContextTypes>(() => {
  return {
    NO_SEND_HEADER: false,
    REQUIRE_LOADER: false,
    IGNORE_ERROR: false,
    NO_VERIFICAR_PERMISOS: false
  };
});

export function checkContextAndCreate(context: ContextOptions): HttpContext {
  let contextObj: ContextTypes = {};
  let contextoToSend: HttpContext;

  if (context.header) Object.assign(contextObj, {NO_SEND_HEADER: true});
  if (context.error) Object.assign(contextObj, {IGNORE_ERROR: true});
  if (context.permisos)
    Object.assign(contextObj, {NO_VERIFICAR_PERMISOS: true});
  if (context.loading) Object.assign(contextObj, {REQUIRE_LOADER: true});

  if (Object.keys(contextObj).length > 0) {
    contextoToSend = new HttpContext().set(CONTEXT, contextObj);
  }

  return contextoToSend;
}
